import Icon from '../components/Icon.vue'

Icon.register({
  'search-location': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M505 442.7c9.3 9.4 9.3 24.6-0.1 34l-28.3 28.3c-9.3 9.4-24.5 9.4-33.9 0l-99.7-99.7c-4.5-4.5-7-10.6-7-17v-16.3c-35.3 27.6-79.7 44-128 44-114.9 0-208-93.1-208-208 0-114.9 93.1-208 208-208 114.9 0 208 93.1 208 208 0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7zM208 352c79.7 0 144-64.5 144-144 0-79.6-64.5-144-144-144-79.6 0-144 64.5-144 144 0 79.6 64.5 144 144 144zM208 112c40.8 0 73.8 33 73.8 73.8 0 33-48.3 93-66.8 114.9-1.5 1.8-4.7 3.3-7.1 3.3s-5.6-1.5-7.1-3.3c-18.5-21.8-66.8-81.9-66.8-114.9 0-40.8 33.1-73.8 73.8-73.8zM208 208c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.3 10.7 24 24 24z'
      }
    ]
  }
})
